import { createSlice } from "@reduxjs/toolkit";
import { User } from "./session.types";
import { login } from "./actions/user.actions";
import { Organization } from "../api/umbraco-api";

export interface SessionState {
  user?: User;
  currentOrganization?: Organization;
}

const initialState: SessionState = {};

const addUser = (state: SessionState, action: ReturnType<typeof login>) => {
  return { ...state, user: action.payload };
};

const logout = (state: SessionState) => {
  return initialState;
};

const setCurrentOrganization = (
  state: SessionState,
  action: { payload: Organization }
) => {
  state.currentOrganization = action.payload;
};

export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    login: addUser,
    logout,
    "set-current-organization": setCurrentOrganization,
    PURGE: logout,
  },
});

export default sessionSlice.reducer;
